import ProcessNavigation from '@/components/process-navigation/index.vue';

export default {
  components: {
    ProcessNavigation
  },
  data() {
    return {
      processList: ['确定身份', '编辑项目信息', '编辑意向供应人（投标人）资格要求', '上传附件信息', '确定承诺信息', '编辑采购文件', '提交申请']
    };
  },
  created () {
  },
  methods: {
    goToList () {
      this.$router.push('/person-center/purchase-business/purchase-project/list');
    }
  }
};
